// extracted by mini-css-extract-plugin
export default {"badge":"badges__badge--wvfy","badge__hotbait":"badges__badge__hotbait--aLij","badge__nearYou":"badges__badge__nearYou--Dbt4","icon":"badges__icon--EZid"};